import axios from "axios";
import config from "@assets/config.json"; // api 请求json

const state = {
};
const mutations = {
};
const getters = {
};

// 微信小程序跳转设置
const actions = {
  getWeChatSkipSettleByPage ({
    rootState
  }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/WeChatSkipSettle/page`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  getWeChatSkipSettleByOne ({
    rootState
  }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/WeChatSkipSettle?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  delWeChatSkipSettleById ({
    rootState
  }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/WeChatSkipSettle?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  addWeChatSkipSettle ({
    rootState
  }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/WeChatSkipSettle`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  editWeChatSkipSettleInfo ({
    rootState
  }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/WeChatSkipSettle`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};